const DashboardEndpoints = {
  getDashboard: "api/dashboard",
  getB2BDashboard: "api/dashboard/b2b",
  DeliveryMetrics: "api/dashboard/b2b/delivery-metrics",
  TopOnTimeBranches: "api/dashboard/b2b/top-on-time-branches",
  VisitTopOnTimeBranches: "api/dashboard/b2b/visit-top-on-time-branches",
  DeliveriesGroupedByDepartureXDockHub:
    "api/dashboard/b2b/deliveries-grouped-by-departure-x-dock-hub",
  DeliveriesGroupedByArrivalXDockHub:
    "api/dashboard/b2b/deliveries-grouped-by-arrival-x-dock-hub",
  getInvoiceDashboard: "api/invoices/invoice-sumamry",
};

export { DashboardEndpoints };
